// Modules
import React, { useState, useEffect, useRef } from 'react'
import TextArea                               from '@shared/textarea'
import Input                                  from '@shared/input'
import { postRequest, pathname }              from "@react/helpers/fetch"
import { jsErbCall }                          from '@react/helpers/jsErbCall'
import consumer                               from 'channels/consumer'

const BUILD_ISSUE_PATH  = "/tickets/:id/build_github_issue"
const CHANNEL           = "ChatGptChannel"
const CREATE_ISSUE_PATH = "/tickets/:id/create_github_issue"

const IssueBody = ({ ticketTitle, ticketId, userId }) => {
  const [state, setState] = useState({ body: '', title: ticketTitle, loading: false, sources: [] })

  const submit = () => {
    if (state.loading && !state.text) return

    setState(prevState => ({ ...prevState, loading: true }))
    const path   = CREATE_ISSUE_PATH.replace(":id", ticketId)
    const format = "json"
    const url    = pathname({ path, format })
    const body   = {
      title: state.title,
      body: state.body
    }

    postRequest({ url, body }).then(() => jsErbCall(`/tickets/${ticketId}`))
  }

  const received = data => {
    if (state.subscription) state.subscription.unsubscribe()

    setState((prevState) => ({
      ...prevState,
      body:    data.text,
      sources: data.tool_calls || [],
      loading: false
    }));
  }

  const improve = () => {
    if (state.loading) return

    setState(prevState => ({ ...prevState, loading: true }))
    const path = BUILD_ISSUE_PATH.replace(":id", ticketId)
    const format = "json"
    const url = pathname({ path, format })
    postRequest({ url })
    .then(() => {
      const params = { channel: CHANNEL, user_id: userId }
      const subscription = consumer.subscriptions.create(params, { received })
      setState(prevState => ({ ...prevState, subscription }))
    })
  }

  useEffect(() => {
    return () => {
      if (state.subscription) {
        state.subscription.unsubscribe()
      }
    }
  }, [state.subscription])

  const canSubmit = !state.loading && state.title?.trim() && state.body?.trim()

  return (
    <>
      <div className="form-group">
        <Input
          label          = {I18n.t("tickets.github_issue_title")}
          validateBtn    = {false}
          defaultValue   = {state.title}
          updateOnChange
          required
          onChange       = {title => setState((prevState) => ({ ...prevState, title }))}
        />
      </div>

      <div className="form-group">
        <label>{I18n.t("tickets.github_issue_description")}</label>
        <TextArea
          onChange      = {body => setState((prevState) => ({ ...prevState, body }))}
          defaultValue  = {state.body}
          defaultHeight = {44}
        />
      </div>

      {state.sources?.length > 0 && (
        <div className="form-group">
          <label>{I18n.t("tickets.github_issue_sources_title")}</label>
          <ul className="text-sm text-gray-600 pl-4">
            {state.sources.map((source, index) => (
              <li key={index}>
                {source.kind === "search"
                  ? `🔍 ${I18n.t("tickets.github_issue_sources_searched")}: ${source.label}`
                  : `📄 ${source.label}`}
                {source.detail ? ` — ${source.detail}` : ""}
              </li>
            ))}
          </ul>
          <p className="text-xs text-gray-400">{I18n.t("tickets.github_issue_sources_hint")}</p>
        </div>
      )}

      <div className="flex flex-end">
        <button
          type="submit"
          className="btn btn-primary mr-2"
          onClick={improve}
          disabled={state.loading}
        >
          {I18n.t("button.complete_with_ai")}
        </button>

        <button
          type="submit"
          className="btn btn-primary"
          onClick={submit}
          disabled={!canSubmit}
        >
          {I18n.t("button.save")}
        </button>
      </div>
    </>
  )
}

export default IssueBody
